import { AppData } from "../../AppDataProvider";
import { Mixpanel } from "../../../mixpanel";

export type BackFromPaymentsStepOpts = {
  appData: AppData;
};

export const backFromPaymentsStep = (
  options: BackFromPaymentsStepOpts,
): AppData => {
  Mixpanel.track({ name: "Went back", props: { from: "payments" } });

  const { bookingData } = options.appData;

  const updatedBookingData = {
    ...bookingData,
  };

  delete updatedBookingData.discountCode;

  return {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: "details",
  };
};
